module.exports = __webpack_public_path__ + "assets/plusBlue.94bfc9c0.svg";